// common/components/mobileHeader/MobileHeader.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme";
import BackButton from "../backButton/BackButton";
import styles from "./MobileHeader.module.scss";

interface MobileHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  rightIcon?: React.ReactNode;
  onRightClick?: () => void;
  avatar?: React.ReactNode;
  stats?: Array<{ value: string | number; label: string }>;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  subtitle,
  showBack = true,
  rightIcon,
  onRightClick,
  avatar,
  stats,
}) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div
      className={styles.mobileHeader}
      style={{ backgroundColor: theme.primary }}
    >
      <div className={styles.mobileHeaderTop}>
        {showBack && (
          <div className={styles.backButton}>
            <BackButton />
          </div>
        )}
        <div className={styles.titleContainer}>
          <h1 className={styles.mobileHeaderTitle}>{title}</h1>
          {subtitle && (
            <div className={styles.mobileHeaderSubtitle}>{subtitle}</div>
          )}
        </div>
        {rightIcon && onRightClick ? (
          <button className={styles.rightButton} onClick={onRightClick}>
            {rightIcon}
          </button>
        ) : (
          <div className={styles.placeholder} />
        )}
      </div>

      {avatar && <div className={styles.avatarContainer}>{avatar}</div>}

      {stats && stats.length > 0 && (
        <div className={styles.statsContainer}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statItem}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
